import type { NotificationMode } from "@/interfaces/CampaignBuilder";

/**
 * Builder send-method predicates shared across Steps 2–4. Both manual and universal are `no_email_invite`
 * send methods (GfG mints links but emails nobody); universal additionally behaves like Manual Path A for
 * pricing + token resolution (no recipient list, a single campaign-level sender). Centralised so the two
 * meanings don't drift across the ~dozen call sites that branch on them.
 */

/** Self-send modes (manual + universal): no GfG email, so the Email design tab is locked and recipients
 *  are never emailed. */
export function isSelfSendMode(mode: NotificationMode): boolean {
  return mode === "manual" || mode === "universal";
}

/**
 * "Anonymous links" shape — no recipient rows, a campaign-level sender, priced by link/redemption
 * quantity rather than a recipient count: Manual Path A (`linkToList !== true`) and EVERY universal
 * campaign. Drives sender/signature-from-campaign token resolution (recipient tags stay literal),
 * the Step-4 quantity pricing, and the "no recipients needed" review gates. Stored recipient rows are
 * kept for when the sender switches back to a list, but are never sent, validated or shown while this
 * holds (GFG-442).
 */
export function isAnonymousLinks(mode: NotificationMode, linkToList: boolean | null): boolean {
  return mode === "universal" || (mode === "manual" && linkToList !== true);
}
